import * as React from "react";
import { Link } from "gatsby";
import { CustomLinkBtn } from "./CustomButton";
import { motion, AnimatePresence } from "framer-motion";
import "../sass/BmMenu.scss";
import {
  HOME_PAGE,
  PRODUCTS_PAGE,
  SUPPORT_PAGE,
} from "../constant/routes";
import { useLocation } from "@reach/router";
import { BiChevronDown, BiChevronRight, BiChevronUp } from "react-icons/bi";
import products from "../../content/products.json";
import ResourcesDropdown from "./ResourcesDropdown";
import { SIGNIN_PAGE, SIGNUP_PAGE } from "../config/router";

export const ResourcesList = ({ setShowResourcesMenu }) => {
  const dropdownRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowResourcesMenu(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <motion.div
      className="lists"
      ref={dropdownRef}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.4,
      }}
    >
      <ul className="dropdown-list">
        <li>
          <Link to="https://blog.webbermill.com/" target="_blank">
            Blog
          </Link>
        </li>
        <li>
          <Link to="">Events</Link>
        </li>
        <li>
          <Link to="">Webinars</Link>
        </li>
        <li>
          <Link to="">Partners</Link>
        </li>
      </ul>
    </motion.div>
  );
};

const HeaderComponent = (props) => {
  const location = useLocation();
  let { pathname } = location;
  const [showProductMenu, setShowProductMenu] = React.useState(false);
  const [showResourcesMenu, setShowResourcesMenu] = React.useState(false);
  const [productName, setProductName] = React.useState("Human Resources");

  const handleOnClick = (value) => {
    setProductName(value);
  };

  const dropdownRef = React.useRef(null);

  console.log(dropdownRef);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowProductMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleClickProductMenu = () => {
    setShowProductMenu((prev) => !prev);
    setShowResourcesMenu(false);
  };

  return (
    <>
      <header className="header" ref={dropdownRef}>
        <div className="header__content container">
          <div className="header__content-logo">
            <Link to={HOME_PAGE}>
              <img
                className="desktop-logo"
                src="https://res.cloudinary.com/webbermill/image/upload/v1679606056/webbermill-website-assets/static/banner/logo_murnrc.svg"
                alt="logo"
                width={30}
              />
              <img
                className="mobile-logo d-none"
                src="https://res.cloudinary.com/webbermill/image/upload/v1679656994/webbermill-website-assets/static/banner/footer-logo_rksy4p.svg"
                alt="logo"
                width={50}
              />
            </Link>
          </div>
          <div className="header__content-lists">
            <ul className="list_items">
              <li
                className={`${showProductMenu && "active"}`}
                onClick={handleClickProductMenu}
              >
                <a>Products</a>
                <span>
                  {showProductMenu ? <BiChevronUp /> : <BiChevronDown />}
                </span>
              </li>
              <li className={`${pathname === "/support" ? "active" : ""}`}>
                <Link to={SUPPORT_PAGE}>Support</Link>
              </li>
              <ResourcesDropdown
                showResourcesMenu={showResourcesMenu}
                setShowResourcesMenu={setShowResourcesMenu}
                setShowProductMenu={setShowProductMenu}
              />
              {props?.hasPrice && (
                <li
                  className={`${
                    pathname === "/transport-suite/pricing" ? "active" : ""
                  }`}
                >
                  <Link to={props?.priceUrl}>Pricing</Link>
                </li>
              )}
            </ul>
          </div>
          <div className="auth-btn">
            <CustomLinkBtn
              text="SIGN IN"
              url={props?.isfrontDesk ? "https://www.frontdesk.webbermill.com/" : "https://id.webbermill.com/account/login"}
            />
            <Link
              to={props?.isfrontDesk ? "https://www.frontdesk.webbermill.com/account/signup" : "https://id.webbermill.com/account/sign-up"}
              target="_blank"
            >
              SIGN UP FOR FREE <BiChevronRight />
            </Link>
          </div>
        </div>

        <AnimatePresence>
          {showProductMenu && (
            <motion.div
              initial={{ y: -300 }}
              animate={{ y: 0 }}
              exit={{ opacity: 0, y: -300 }}
              transition={{
                duration: 0.4,
              }}
              className="header__sub"
              // ref={dropdownRef}
            >
              <div className="contents">
                <div className="container">
                  {products.map((product) => (
                    <a
                      onClick={() => handleOnClick(product?.title)}
                      className={`${
                        product?.title === productName && "active"
                      }`}
                    >
                      {product?.title}
                    </a>
                  ))}
                </div>
              </div>
              <div className="py-6 container sub-content">
                {products
                  .filter((product) => product.title === productName)
                  .map((product) => (
                    <>

                      {product?.products?.map((item) => (
                        <Link to={item?.path}>
                          <div className="products-card">
                            <img src={item.icon} alt={item.name} />
                            <div className="text-section">
                              <h5>{item.name}</h5>
                              <p>{item.description}</p>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </>
                  ))}
              </div>
              <div className="btn">
                <Link to={PRODUCTS_PAGE}>
                  View all product <BiChevronRight />
                </Link>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </header>
    </>
  );
};

export default HeaderComponent;
